import Loancalculation from "../../../jsx/components/Dashboard/LoanCalculation/loancalculation";

const LoanCalculationWrapper = () => {
  return <Loancalculation />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.customer];
export default constore(LoanCalculationWrapper);
